import {
  ADD_EDIT_GOALS_ASSESSMENT_FAILURE,
  ADD_EDIT_GOALS_ASSESSMENT_REQUEST,
  ADD_EDIT_GOALS_ASSESSMENT_SUCCESS,
  ADD_PERSONAL_SMART_GOALS_FAILURE,
  ADD_PERSONAL_SMART_GOALS_REQUEST,
  ADD_PERSONAL_SMART_GOALS_SUCCESS,
  ADD_WHERE_TO_FROM_HERE_FAILURE,
  ADD_WHERE_TO_FROM_HERE_REQUEST,
  ADD_WHERE_TO_FROM_HERE_SUCCESS,
  DELETE_PERSONAL_SMART_GOALS_FAILURE,
  DELETE_PERSONAL_SMART_GOALS_REQUEST,
  DELETE_PERSONAL_SMART_GOALS_SUCCESS,
  GET_CURRENT_SLP_GOALS_PDF_REQUEST,
  GET_CURRENT_SLP_GOALS_PDF_SUCCESS,
  GET_CURRENT_SLP_GOALS_PDF_FAILURE,
  GET_PERSONAL_SMART_GOALS_BY_SLP_ID_FAILURE,
  GET_PERSONAL_SMART_GOALS_BY_SLP_ID_REQUEST,
  GET_PERSONAL_SMART_GOALS_BY_SLP_ID_SUCCESS,
  GET_PERSONAL_SMART_GOALS_FAILURE,
  GET_PERSONAL_SMART_GOALS_REQUEST,
  GET_PERSONAL_SMART_GOALS_SUCCESS,
  HOPES_GOALS_AMBITIONS_FAILURE,
  HOPES_GOALS_AMBITIONS_REQUEST,
  HOPES_GOALS_AMBITIONS_SUCCESS,
  UPDATE_HOPES_GOALS_AMBITIONS_FAILURE,
  UPDATE_HOPES_GOALS_AMBITIONS_REQUEST,
  UPDATE_HOPES_GOALS_AMBITIONS_SUCCESS,
} from "./actionTypes";
import { SlpFormActions, SlpFormState } from "./types";

const initialState: SlpFormState = {
  pending: false,
  hopesGoalsAndAmbitionsData: null,
  personalAndSmartGoalsData: [],
  personalAndSmartGoalsDataBySlpId: [],
  goalsPDF: "",
  error: null,
};

const reducers = (state = initialState, action: SlpFormActions): unknown => {
  switch (action.type) {
    case HOPES_GOALS_AMBITIONS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case HOPES_GOALS_AMBITIONS_SUCCESS:
      return {
        ...state,
        pending: false,
        hopesGoalsAndAmbitionsData: action.payload.hopesGoalsAndAmbitionsData,
        error: null,
      };
    case HOPES_GOALS_AMBITIONS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case UPDATE_HOPES_GOALS_AMBITIONS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case UPDATE_HOPES_GOALS_AMBITIONS_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case UPDATE_HOPES_GOALS_AMBITIONS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case ADD_PERSONAL_SMART_GOALS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case ADD_PERSONAL_SMART_GOALS_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case ADD_PERSONAL_SMART_GOALS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case ADD_EDIT_GOALS_ASSESSMENT_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case ADD_EDIT_GOALS_ASSESSMENT_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case ADD_EDIT_GOALS_ASSESSMENT_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case DELETE_PERSONAL_SMART_GOALS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case DELETE_PERSONAL_SMART_GOALS_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case DELETE_PERSONAL_SMART_GOALS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case GET_PERSONAL_SMART_GOALS_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case GET_PERSONAL_SMART_GOALS_SUCCESS:
      return {
        ...state,
        personalAndSmartGoalsData: action.payload.personalAndSmartGoalsData,
        personalAndSmartGoalsPagination:
          action.payload.personalAndSmartGoalsPagination,
        pending: false,
      };
    case GET_PERSONAL_SMART_GOALS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case GET_PERSONAL_SMART_GOALS_BY_SLP_ID_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case GET_PERSONAL_SMART_GOALS_BY_SLP_ID_SUCCESS:
      return {
        ...state,
        personalAndSmartGoalsDataBySlpId:
          action.payload.personalAndSmartGoalsData,
        personalAndSmartGoalsPaginationBySlpId:
          action.payload.personalAndSmartGoalsPagination,
        pending: false,
      };
    case GET_PERSONAL_SMART_GOALS_BY_SLP_ID_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case GET_CURRENT_SLP_GOALS_PDF_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case GET_CURRENT_SLP_GOALS_PDF_SUCCESS:
      return {
        ...state,
        goalsPDF: action.payload.goalsPDF,
        pending: false,
      };
    case GET_CURRENT_SLP_GOALS_PDF_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    case ADD_WHERE_TO_FROM_HERE_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case ADD_WHERE_TO_FROM_HERE_SUCCESS:
      return {
        ...state,
        pending: false,
        success: action.payload,
        error: null,
      };
    case ADD_WHERE_TO_FROM_HERE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducers;
